<template>
  <div class="home-news-item">
    <img v-if="item.tile_image && seen" :src="$k.imagebase + 'images/news/' + item.news_id + '/crop/' + item.tile_image" 
        class="home-news-tile" />
    <div class="news-panel">
      <div class="news-panel-title">{{ item.title }}</div>
      <div class="home-news-panel-summary" v-html="item.summary"></div>
      <div class="home-artist-button-panel" v-if="artist">
        <small-button large v-on:click="visitPortfolio">{{ $nippets.replace('newsPage.visitPortfolio','fname', firstName )}}</small-button>
      </div>
      <div class="home-artist-button-panel">
        <small-button large brown v-on:click="goStory()">{{ $nippets.newsPage.readTheStory }}</small-button>
      </div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
export default {
  mixins: [ViewablePanel],
  props: {
    item: Object
  },
  computed: {
    firstName: function () {
      if(this.artist) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    }
  },
  data () {
    return {
      artist: null,
      imsrc: '',
      loaded: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    getMatchingArtist (keys) {
      for(var item of keys) {
        let a = this.$store.getters.getMatchingArtist(item)
        if(a) return a
      }
      return null
    },
    async init () {
      let keys = this.item.tags.split('#')
      await this.$store.dispatch('fetchArtists')
      this.artist = this.getMatchingArtist(keys)
      
    },
    goStory () {
      this.$ixr.push(this.item.permalink)
    },
    visitPortfolio () {
      if(this.artist) {
        this.$ixr.push(this.$k.getPortfolioLink(this.artist))
      }
    }
  },
  watch: {
    item () {
      this.init()
    }
  }
}
</script>

<style scoped>
.home-news-item{
  width:100%;
  height:100%;
  background-color:#efefea;
  position:relative;
  overflow:hidden;
  margin-bottom:15px;
}

.home-news-item:last-child{
  margin-bottom:0;
}

.home-news-item img{
  width:100%;
}

.news-panel{
  background-color:#efefea;
  position:absolute;
  bottom:0;
  width:100%;
  box-sizing: border-box;
  padding:16px;
  transition:all 0.3s ease;
}

.news-panel-title{
  font-weight:500;
  color:#ce0e2d;
  font-weight:700;
  font-size:19px;
}


.home-news-panel-summary{
  height:auto;
  padding:8px 0px;
  margin-bottom:10px;
}

.home-artist-button-panel{
  max-height: 90px;
  padding-bottom:8px;
}

.home-news-item .home-news-tile{
  transition:all 0.4s ease;
}

.home-news-item:hover .home-news-tile{
  transform:scale(1.05);
}
</style>